import useSWR, { SWRConfiguration } from "swr";

const frontendFetcher = async (path: string) => {
  const url = `${window.location.origin}${path.startsWith("/") ? path : `/${path}`}`;
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error(`Failed to fetch: ${res.statusText}`);
  }

  return res.json();
};

/**
 * Used to fetch data from the frontend API.
 */
export const useFrontendQuery = <T = any>(path: string, config?: SWRConfiguration) => {
  return useSWR<T>(path, frontendFetcher, config);
};
